import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { DefaultConstant } from '../../../../../constants/enum/common/default.enum';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { MakeLoopScanComponent } from '../make-loop-scan/make-loop-scan.component';

@Component({
  standalone: false,
  selector: 'kt-start-loop',
  templateUrl: './start-loop.component.html',
  styleUrls: ['./start-loop.component.scss'],
})
export class StartLoopComponent extends ModalBaseClass implements OnInit, AfterViewInit {
  loops = [];
  location = { latitude: CommonUtil.Latitude, longitude: CommonUtil.Longitude };
  distanceFromActualLocation = 0;
  shiftInfo = null;
  selectedLoop = null;
  user_id = null;
  @ViewChild('wizard', { static: true }) el: ElementRef;
  isLastStepReached = false;
  buttonConfig = BUTTON_CONFIG;
  defaultEnum = DefaultConstant;
  preselectLoopId = 0;
  loading = signal(false);
  mapReady = signal(false);
  infoContent = '';
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  private readonly mapsLoader = inject(GoogleMapsLoaderService);

  constructor(private scheduleStoreService: ScheduleStoreService, private timesheetStoreService: TimesheetStoreService, private activeModal: NgbActiveModal, private ngbModal: NgbModal, private cdr: ChangeDetectorRef) {
    super(ngbModal);
    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.longitude = position.coords.longitude;
        this.distanceFromActualLocation = CommonUtil.distance(this.location.latitude, this.location.longitude, (+this.shiftInfo.area.area_latitude), (+this.shiftInfo.area.area_longitude), 'K');
      });
    }
  }


  openInfoWindow(marker: MapMarker, content: string) {
    this.infoContent = content;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  ngOnInit() {
    this.dispatchGetStartLoop();
  }


  ngAfterViewInit() {
    setTimeout(() => {
      const wizard = new KTWizard(this.el.nativeElement, {
        startStep: 1,
      });
      wizard.on('beforeNext', (wizardObj) => {
        this.isLastStepReached = true;
        this.cdr.detectChanges();
      });
      wizard.on('beforePrev', (wizardObj) => {
        this.isLastStepReached = false;
        this.cdr.detectChanges();
      });

    }, 100);
  }

  loopViewclickHandler(loop, actualLoop = null) {
    const compRef = this.openPopUp(MakeLoopScanComponent, { viewMode: true, loopDetail: loop, shiftInfo: this.shiftInfo, actualLoop }, { centered: true, size: 'lg', backdrop: 'static' });
  }

  setLoopData(data) {
    if (data.success) {
      this.loops = data.data.data.loop || [];
      this.selectedLoop = this.loops && this.loops.length ? this.loops[0] : null;
      if (this.preselectLoopId) {
        const loop = this.loops.find(l => l.loop_id === this.preselectLoopId);
        this.selectedLoop = loop;
      }
    }
  }


  saveClickHandler() {
    if (this.loading()) {
      return;
    }
    const payload = {
      loop_id: this.selectedLoop.loop_id,
      shift_loop_id: this.selectedLoop.shift_loop_id,
      type: this.selectedLoop.shift_loop_id ? TimesheetType.SHIFT : TimesheetType.LOCATION,
      timesheet_id: this.shiftInfo && this.shiftInfo.timesheet ? this.shiftInfo.timesheet.timesheet_id : null,
      timezone_id: 0,
      user_id: this.user_id ? this.user_id : 0,
      is_unscheduled: this.shiftInfo.shift ? false : true,
      timesheet_log: {
        timesheet_log_name: this.selectedLoop.loop_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: false,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.longitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
    };
    this.dispatchStartLoop(payload);
  }

  statedLoop(data) {
    this.loading.set(false);
    if (data.success) {
      this.activeModal.close({ reload: true });
    }
  }

  dispatchGetStartLoop() {
    this.scheduleStoreService.dispatchScheduleCommon({
      callback: this.setLoopData.bind(this),
      module: SCHEDULE_METHOD_CONSTANT.GET_SHIFT_LOOP,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: {
        shift_id: this.shiftInfo && this.shiftInfo.shift ? this.shiftInfo.shift.shift_id : 0,
        timesheet_id: this.shiftInfo && this.shiftInfo.timesheet ? this.shiftInfo.timesheet.timesheet_id : 0,
        type: this.shiftInfo && this.shiftInfo.timesheet && this.shiftInfo.timesheet.timesheet_id ? TimesheetType.TIMESHEET : TimesheetType.SHIFT,
      },
    });
  }

  dispatchStartLoop(payload) {
    this.loading.set(true);
    this.timesheetStoreService.dispatchTimesheetCommon({
      callback: this.statedLoop.bind(this),
      module: TIMESHEET_METHOD_CONSTANT.START_LOOP,
      method: API_METHOD_CONSTANTS.INSERT,
      data: payload,
    });
  }
}
